const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
  },
  title: {
    fontWeight: 700,
    color: '#0F172A',
    fontSize: '18px',
  },
  subtitle: {
    color: '#64748B',
    fontSize: '14px',
  },
  fileListContainer: {
    border: '1px solid #E2E8F0',
    borderRadius: '12px',
    overflow: 'hidden',
    backgroundColor: '#FFFFFF',
  },
  fileListHeader: {
    padding: '12px 16px',
    backgroundColor: '#F8FAFC',
    borderBottom: '1px solid #E2E8F0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  fileList: {
    maxHeight: '400px',
    overflowY: 'auto',
  },
  fileItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 16px',
    gap: '12px',
    borderBottom: '1px solid #F1F5F9',
    transition: 'background-color 0.2s',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#F8FAFC',
    },
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  fileIcon: {
    color: '#3B82F6',
    fontSize: '20px',
  },
  fileName: {
    flex: 1,
    fontSize: '14px',
    color: '#1E293B',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  fileSize: {
    fontSize: '12px',
    color: '#94A3B8',
    minWidth: '60px',
    textAlign: 'right',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '16px',
    padding: '16px 24px',
    borderRadius: '12px',
    backgroundColor: '#F8FAFC',
    border: '1px solid #E2E8F0',
  },
  backButton: {
    textTransform: 'none',
    fontWeight: 600,
    color: '#64748B',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#0F172A',
    },
  },
  processButton: {
    textTransform: 'none',
    borderRadius: '10px',
    fontWeight: 600,
    padding: '10px 24px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
  },
  checkbox: {
    padding: '4px',
    color: '#CBD5E1',
    '&.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
})

export default styles
